import React, {Component} from "react";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {PropagateLoader} from 'react-spinners';

import {
    TableCell,
    TableRow,
    TableHead,
    TableBody,
    Table,
} from "@mui/material";

import ImportReportRow from "./components/ImportReportRow";

// styles
import expansionStyle from "assets/jss/views/report/expansionStyle";
import {primaryColor} from "assets/jss/main";
import {withStyles} from "@mui/styles";



class HistoryTable extends Component {
    static propTypes = {
        loading: PropTypes.bool.isRequired,
    };

    render() {
        const {classes, tableData} = this.props;
        if (this.props.loading) {
            return (
                <div className={classes.propagateLoader}>
                    <PropagateLoader
                        sizeUnit={"px"}
                        size={16}
                        color={primaryColor}
                        loading={this.props.loading}
                    />
                </div>
            );
        }

        if (!tableData || tableData["hydra:member"].length === 0) {
            return (
                <div>
                    <FormattedMessage id={"feed.history.noResult"}/>
                </div>
            );
        }

        const rows = tableData["hydra:member"];
        const hasRows = rows && rows.length > 0;

        return (
            <div className={classes.tableResponsive}>
                <div className={classes.table}>
                    <Table padding={hasRows ? "none" : "default"}>
                        <TableHead
                            state={this.state}
                            offer={this.props.offer}
                        >
                            <TableRow>
                                <TableCell><FormattedMessage id={'feed.history.detail.label.start'}/></TableCell>
                                <TableCell><FormattedMessage id={'feed.history.detail.label.end'}/></TableCell>
                                <TableCell># Références</TableCell>
                                <TableCell>% Variation</TableCell>
                                <TableCell><FormattedMessage id={'feed.history.list.label.count_errors'}/></TableCell>
                                <TableCell>Statut</TableCell>
                                <TableCell align={'right'}>Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows.map((importReport, index) => (
                                <ImportReportRow
                                    key={index}
                                    importReport={importReport}
                                    previousImportReport={rows[index + 1]}
                                    retailerId={this.props.retailerId}
                                    feedId={this.props.feedId}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.report.list.loading,
});

export default connect(
    mapStateToProps
)(withStyles(expansionStyle)(injectIntl(HistoryTable)));
